import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Icon, Radio, Tooltip, Divider, Checkbox, Select } from 'antd';
import { Beneficiary } from '../../../../models';
import { connect } from 'react-redux';
import { alertify, handleApiExceptions } from '../../../../app_methods';
import { beneficiaryOrganisationTypes as  organisationTypes } from '../../../../constants';


let BeneficiaryForm = (props) => {
    const { form, beneficiary } = props;
    const { getFieldDecorator } = form;
    const validations = Beneficiary.validations;
    const userPaymentModes = props?.current_user?.payment_modes; 
    // const virtual_accounts = props.current_user.virtual_accounts ?? []
    // const virtual_account =  virtual_accounts.find((va) =>va.virtual_account_number === beneficiary.account_number) || {}

    const [isVerifying, setIsVerifying] = useState(false);
    const [beneficiaryTypeForm, setBeneficiaryTypeForm] = useState({})

    const currentBeneficiaryType = (props) => {
        if (userPaymentModes?.some(m => ["IMPS", "NEFT", "RTGS"].includes(m))) {
            setBeneficiaryTypeForm({ beneficiary_type: "bank_account" })
        }
        else if (userPaymentModes?.includes("UPI")) {
            setBeneficiaryTypeForm({ beneficiary_type: "upi" })
        }
        else if (userPaymentModes?.includes("AMAZON_WALLET")) {
            setBeneficiaryTypeForm({ beneficiary_type: "amazon_wallet" })
        }
    }

    useEffect(() => {
        currentBeneficiaryType(props)
    }, [])

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            if( form.getFieldValue("onboard_on_sbi")){
                    props.renderBankOTPModal('SBI', form.getFieldsValue());
            }
            if (values.beneficiary_type === "amazon_wallet") {
                const updatedUpiHandle = `${values.upi_handle}@amazonpay`;
                form.setFieldsValue({ upi_handle: updatedUpiHandle });
            }
            props.onSubmit(form.getFieldsValue());
            form.setFieldsValue({
                upi_handle: values.upi_handle.replace("@amazonpay", ""),
            });
        });
    }

    const verifyUPIHandle = () => {
        if (!form.getFieldValue("upi_handle")) return;
        setIsVerifying(true);
        Beneficiary.verify_vpa({ vpa: form.getFieldValue("upi_handle") }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status == "valid") beneficiary_name = response.data.account_holder_name;
                else if (["invalid", "failure"].includes(response.data.status)) alertify("Oops!", "Entered UPI Handle is invalid.", "error");
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const verifyBankAccount = () => {
        if (!form.getFieldValue("account_number") || !form.getFieldValue("ifsc")) return;
        setIsVerifying(true);
        Beneficiary.verify_bank_account({
            account_no: form.getFieldValue("account_number"),
            ifsc: form.getFieldValue("ifsc")
        }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status != "valid") handleApiExceptions("Bank account details are invalid.");
                else beneficiary_name = response.data.account_holder_name;
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const renderVAExtra = () => {
        return (
            props.current_user.euv ?
                <Button type="link" size="small" loading={isVerifying} onClick={verifyUPIHandle}>Verify</Button> : null
        )
    };

    const renderBankAccountDetailsForm = () => {
        return (
            <>
                <Form.Item label="Account Number">
                    {getFieldDecorator("account_number", {
                        initialValue: beneficiary.account_number,
                        rules: validations.account_number
                    })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                </Form.Item>

                <Form.Item className="mb-0" label="Account IFSC Code">
                    {getFieldDecorator("ifsc", {
                        initialValue: beneficiary.account_ifsc,
                        rules: validations.ifsc
                    })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                </Form.Item>

                {
                    props.current_user.ebav ?
                        <>
                            <div className="mt-1 d-flex justify-content-end">
                                <Button className="px-0" type="link" onClick={verifyBankAccount} loading={isVerifying}>Verify Bank Account</Button>
                            </div>
                            <Divider style={{ marginTop: 10, marginBottom: 10, background: "#dddddd" }} />
                        </> : null
                }
            </>
        )
    };

    const renderUpiDetailsForm = () => {
        return (
            <Form.Item label="UPI Handle">
                {getFieldDecorator("upi_handle", {
                    initialValue: beneficiary.upi_handle,
                    rules: validations.upi_handle
                })(<Input autoComplete='off' id="upi_handle" prefix={<Icon type="qrcode" />} addonAfter={renderVAExtra()} />)}
            </Form.Item>
        )
    };

    const renderAmazonWalletForm = () => {
        return (
            <Form.Item label="Amazon Wallet Handle">
                {getFieldDecorator("upi_handle", {
                    initialValue: beneficiary.upi_handle || "",
                    rules: validations.phone_number
                })(
                    <Input
                        autoComplete="off"
                        id="amazon_wallet"
                        placeholder="Enter mobile number"
                        prefix={<Icon type="amazon" />}
                        addonAfter="@amazonpay"
                    />
                )}
            </Form.Item>
        );
    };



    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: beneficiary.uuid,
                rules: validations.uuid
            })(<Input autoComplete='off' hidden />)}

            {getFieldDecorator("contact_id", {
                initialValue: props.contact.uuid,
                rules: validations.contact_id
            })(<Input autoComplete='off' hidden />)}

            <div className="mb-4">
                {getFieldDecorator("beneficiary_type", {
                    initialValue: beneficiaryTypeForm?.beneficiary_type,
                    rules: validations.beneficiary_type
                })(
                    <Radio.Group style={{ display: "flex"}}>
                        {
                            props.current_user.payment_modes.some(m => ["IMPS", "NEFT", "RTGS"].includes(m)) ?
                            <Radio.Button style={{flexGrow: 1}} value="bank_account">Bank Account</Radio.Button> : null
                        }
                        {
                            props.current_user.payment_modes.includes("UPI") ?
                                <Radio.Button value="upi">UPI Handle</Radio.Button> : null
                        }
                        {
                            props.current_user.payment_modes.includes("AMAZON_WALLET") ?
                                <Radio.Button value="amazon_wallet">Amazon Wallet</Radio.Button> : null
                        }
                    </Radio.Group>
                )}
            </div>

            {form.getFieldValue("beneficiary_type") === "bank_account"
                ? renderBankAccountDetailsForm()
                : form.getFieldValue("beneficiary_type") === "amazon_wallet"
                    ? renderAmazonWalletForm()
                    : renderUpiDetailsForm()}


            <Form.Item label="Beneficiary Name">
                {getFieldDecorator("beneficiary_name", {
                    initialValue: beneficiary.beneficiary_name,
                    rules: validations.beneficiary_name
                })(<Input autoComplete='off' prefix={<Icon type="user" />} />)}
            </Form.Item>

            { props.current_user?.merchant_active_on_sbi && form.getFieldValue("beneficiary_type") == "bank_account"?
            <Form.Item >
                {getFieldDecorator("onboard_on_sbi", {
                    initialValue: false,
                    valuePropName: "checked"
                })(<Checkbox autoFocus disabled={!form.getFieldValue("account_number")} >Add as SBI Beneficiary</Checkbox>)}
            </Form.Item>:null}

            <div className="row">
                 <div className="col-sm-6">
                     <Form.Item autoComplete="off" label="User ID">
                        {getFieldDecorator("beneficiary_user_id", {
                        })(<Input autoComplete="off" prefix={<Icon type="user" />} />)}
                    </Form.Item>
                 </div>
                 <div className="col-sm-6">
                     <Form.Item autoComplete="off" label="PAN Number">
                        {getFieldDecorator("pan_number", {
                            rules: validations.pan_number,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                 </div>
                 
                 <div className="col-sm-6">
                    <Form.Item autoComplete="off" label="Organisation Type">
                        {getFieldDecorator("organisation_type", {
                        rules: validations.organisation_type,
                        })(
                        <Select placeholder="Select Organisation Type">
                            {organisationTypes.map(({ label, value }) => (
                                <Select.Option key={value} value={value}>
                                {label}
                                </Select.Option>
                            ))}
                        </Select>
                        )}
                    </Form.Item>
                 </div>
                 <div className="col-sm-6">
                     <Form.Item autoComplete="off" label="Business Model">
                        {getFieldDecorator("business_model", {
                            rules: validations.business_model,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                 </div>
                 <div className="col-sm-6">
                     <Form.Item autoComplete="off" label="CIN Number">
                        {getFieldDecorator("cin_number", {
                            rules: validations.cin_number,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                 </div>
                 <div className="col-sm-6">
                     <Form.Item autoComplete="off" label="GST Number">
                        {getFieldDecorator("gst_number", {
                            rules: validations.gst_number,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                 </div>
            </div>

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Create</Button>
            </div>
        </Form>
    )
};

BeneficiaryForm.defaultProps = {
    beneficiary: {},
    contact: {}
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

BeneficiaryForm = Form.create()(BeneficiaryForm);

export default connect(mapStateToProps)(BeneficiaryForm);